export default "__VITE_ASSET__bde80b4d__"